<template>
  <div class="pt-50">
    <p><span>{{ text }}</span></p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },

}
</script>

<!-- Create new scss file if you add more than two classes inside component -->
<style lang="scss" scoped>
p {
   width: 100%;
   text-align: center;
   border-bottom: 1px solid #E0E5EB;
   line-height: 0.1em;
   margin: 10px 0 34px;
}

p span {
    background:#fff;
    padding:0 10px;
}
</style>
